import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button, { ButtonProps } from '@mui/material/Button'
import Card from '@mui/material/Card'
import NumberFormat, { FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat';
import LinkToPayments from 'cityads-v3/containers/webmaster/payments/LinkToPayments';

import classes from './Profile.scss';
import { RootState } from 'cityads-v3/types/reducer';

type CreditProps = {
  onClose?: ButtonProps['onClick']
}

export default function Credits({
  onClose,
}: CreditProps): JSX.Element {
  const { t } = useTranslation(['Payments', 'main'])
  const balance = useSelector((state: RootState) => state.auth.balance)
  const needDocumentForPayment = useSelector((state: RootState) => state.header.needDocumentForPayment)
  const promo = useSelector((state: RootState) => state.auth.balance.promo || [])

  return (
    <Card
      classes={{ root: classes.pageContainer }}
    >
      <div className={classes.credits}>
        <div className={classes.totals}>
          <div>{t('balance.holdAdvertiser')}</div>
          <NumberFormat
            number={balance.hold_advertiser}
            format={FORMAT_CURRENCY}
            currency={balance.currency}
          />
        </div>
        <div className={classes.totals}>
          <div>{t('balance.available')}</div>
          <NumberFormat
            number={balance.available}
            format={FORMAT_CURRENCY}
            currency={balance.currency}
          />
        </div>
        <div className={classes.totals}>
          <div>{t('balance.onOutput')}</div>
          <NumberFormat
            number={balance.on_output}
            format={FORMAT_CURRENCY}
            currency={balance.currency}
          />
        </div>
        {needDocumentForPayment ? (
          <div className={classes.totals}>
            <Trans t={t} i18nKey={'balance.needDocumentForPayment'} parent="div">
              A <LinkToPayments>document is required</LinkToPayments> to calculate payment!
            </Trans>
          </div>
        ) : false}

        {promo.map(item => (
          <div className={classes.totals} key={item.name}>{item.hint}</div>
        ))}

      </div>

      <div className={classes.cardActions}>
        <Button
          component={Link as React.ElementType}
          to="/publisher/profile/credits/currencies"
          onClick={onClose}
        >
          {t('main:more_info')}
        </Button>

        <Button
          color="primary"
          component={LinkToPayments}
          variant="contained"
          onClick={onClose}
        >
          {t('title')}
        </Button>
      </div>
    </Card>
  )
}
